import { Box } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb, SnackSimple } from "../../../../components"
import { CustomPaper } from "../../../../components/CustomPaper"
import { useBody } from "./body"
import ListDrop from "./components/list"
import ListForm from "./components/form"
import SimpleModal from "../../../../components/modal/simpleModal"
import { useTranslation } from "react-i18next"

const DropDownLst = () => {
    const styles = useStyles()
    const body = useBody()
    const { t } = useTranslation()

    return (
        <Box sx={styles.container}>

            <BreadCrumb removeBreadcrumb={['setting']} />

            <SnackSimple open={body.snackbarOpen.open} close={body.closeSnackBarOpen} message={body.snackbarOpen.message} type={body.snackbarOpen.type} />

            <Box sx={styles.containerPaper}>
                <CustomPaper elevation={3} sx={styles.paperR}>
                    <ListDrop handleCreate={body.handleCreate} column={body.column} filterDropList={body.filterDropList} input={body.input} isLoading={body.isLoading} row={body.row} totalPages={body.totalPages} />
                </CustomPaper>

                <CustomPaper elevation={3} sx={styles.paperL}>
                    <ListForm setIdEdit={body.setIdEdit} loadingItem={body.loadingItem} loadingSubmit={body.loadingSubmit} hadleSubmit={body.hadleSubmit} setTouched={body.setTouched} touched={body.touched} ref={body.formRef} closeModal={body.closeModal} setModal={body.setModal} mode={body.mode} setMode={body.setMode} editName={body.nameEdit} editValues={body.valuesEdit} id={body.idEdit} />
                </CustomPaper>
            </Box>

            <SimpleModal
                open={!!body.modal.open}
                next={body.modal.confirm}
                back={body.closeModal}
                close={body.closeModal}
                description={body.modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={body.modal.title}
                loadingButton
                isLoading={body.isLoadingModal}
            />

        </Box>
    )
}

export default DropDownLst
